const isDefined = <T>(data: T | undefined): data is T => data !== undefined;

export default isDefined;
